/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const getConsumptionHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contact count
 */
export const getConsumption200Schema = z.object({
    "count": z.int().min(-9007199254740991).max(9007199254740991),
"maxContactsAllowed": z.int().min(-9007199254740991).max(9007199254740991),
"remaining": z.int().min(-9007199254740991).max(9007199254740991)
    })

export const getConsumptionQueryResponseSchema = z.lazy(() => getConsumption200Schema)